document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-banner-swiper').forEach((slider) => {
    if (slider.swiper) return;

    new Swiper(slider, {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  });
  document.querySelectorAll('.community-reviews__slider').forEach((slider) => {
    if (slider.swiper) return;

    const wrapper = slider.closest('.community-reviews__main-slider');

    new Swiper(slider, {
      loop: true,
      speed: 800,
      slidesPerView: 2,
      spaceBetween: 16,

      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      //   pauseOnMouseEnter: true,
      // },

      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },

      navigation: {
        prevEl: wrapper.querySelector('.arrow-prev-reviews'),
        nextEl: wrapper.querySelector('.arrow-next-reviews'),
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        }
      }
    });
  });

  document.querySelectorAll('.collection-swiper').forEach((slider) => {
    if (slider.swiper) return;

    new Swiper(slider, {
      loop: false,
      speed: 800,
      pagination: false,
      slidesPerView: "auto",
      spaceBetween: 16,
      navigation: {
        nextEl: ".collection-swiper-arrow .swiper-button-next-c",
        prevEl: ".collection-swiper-arrow .swiper-button-prev-c",
      },
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const closeBtn = document.querySelector('.announcement-bar__close');
  const announcementBar = document.querySelector('.announcement-bar');

  if (!announcementBar) return;

  function updateAnnouncementHeight() {
    const height = announcementBar.classList.contains('is-hidden')
      ? 0
      : announcementBar.offsetHeight;

    document.documentElement.style.setProperty(
      '--announcement-height',
      height + 'px'
    );
  }

  updateAnnouncementHeight();

  if (!closeBtn) return;

  closeBtn.addEventListener('click', () => {
    announcementBar.classList.add('is-hidden');

    setTimeout(updateAnnouncementHeight, 50);
  });
});


// pagination
(function () {
  function updateBannerPagination() {
    if (window.innerWidth > 767) return;

    const swiper = document.querySelector('.home-banner-swiper');
    if (!swiper) return;

    const pagination = swiper.querySelector('.swiper-pagination');
    const activeSlide = swiper.querySelector('.swiper-slide-active .home-banner-content');

    if (!pagination || !activeSlide) return;

    const contentHeight = activeSlide.offsetHeight;
    pagination.style.bottom = (contentHeight + 72) + 'px';
    pagination.style.transform = 'translateY(0)';
  }

  window.addEventListener('load', updateBannerPagination);

  window.addEventListener('resize', updateBannerPagination);

  document.addEventListener('DOMContentLoaded', function () {
    if (window.homeBannerSwiper) {
      window.homeBannerSwiper.on('slideChangeTransitionEnd', updateBannerPagination);
    }
  });
})();

